import CircleIcon from '@mui/icons-material/Circle';
import { superstyled } from '@zenbusiness/zui/styles';

export const StatusCircleIcon = superstyled({
  tag: CircleIcon,
  name: 'WhatsNext',
  slot: 'StatusCircleIcon',
  styles: ({ theme }) => ({
    width: 8,
    height: 8,
    color: theme.palette.text.secondary,
  }),
});
